<template>
    <div class="change_pwd">
      <p class="change_pwdTop">
        <span @click="back"><img src="../../assets/images/users/Return.png"></span>
        <span>パスワード変更</span>
        <span></span>
      </p>
      <div class="change_pwd_input">
        <input type="password" name="yuanPwd" v-model="yuanPwd" placeholder="原パスワード">
        <span v-show="errors.has('yuanPwd')" class="error">{{ errors.first('yuanPwd') }}</span>
      </div>
      <div class="change_pwd_input">
        <input type="password" name="newPwd" v-model="newPwd" placeholder="新パスワード">
        <span v-show="errors.has('newPwd')" class="error">{{ errors.first('newPwd') }}</span>
      </div>
      <div class="change_pwd_input">
        <input type="password" name="reNewPwd" v-model="reNewPwd" placeholder="パスワード確認">
        <span v-show="errors.has('reNewPwd')" class="error">{{ errors.first('reNewPwd') }}</span>
        <span class="error">{{ errMessage }}</span>
      </div>
      <button @click="conirm_pwd">パスワードOK</button>

    </div>
</template>

<script>
  import {resetPwd} from './../../api/interface/users'
  import VeeValidate, {Validator} from 'vee-validate'
  import cn from 'vee-validate/dist/locale/zh_CN'
  Validator.localize('cn', cn);
  const dict = {
    cn: {messages: {required: (name) => `${name}必要!`}}
  };
  Validator.localize(dict);
  export default{
    name: "",
    validator: null,
    data(){
      return {
        errors: null,
        start: false,
        yuanPwd: "",
        newPwd: "",
        reNewPwd: "",
        errMessage: ""
      }
    },
    methods: {
      conirm_pwd(){
        this.validator.validateAll({
          yuanPwd: this.yuanPwd,
          newPwd: this.newPwd,
          reNewPwd: this.reNewPwd,
        }).then(result => {
          let pwdInfo = {
            pwd: this.yuanPwd,
            newPwd: this.newPwd,
            reNewPwd: this.reNewPwd,
          }
          if (result) {
            resetPwd(pwdInfo).then(result => {
              if (result.code == 1) {
                this.$message({
                  message: 'パスワード再設定しました、ロクインページに移動します',
                  type: 'success',
                  duration: "500"
                });
                this.$router.push({path: "/login"})
              }
              console.log(result);
            }).catch(err => {
              if (err.code == 4) {
                this.errMessage = "原パスワードの入力に誤りがあリます"
              }
              console.log(err);
            })
          }
        })
      },
      back(){
        this.$router.go(-1)
      }
    },
    components: {},
    created(){
      this.validator = new Validator({});  // 初始化Validator对象
      Validator.extend('yuanPwd', {
        getMessage: field => '入力内容が正しくありません',
        validate: value => /(?=.*[a-zA-Z])(?=.*[\d])[\w\W]{6,20}/.test(value)  // 验证条件
      });
      Validator.extend('newPwd', {
        getMessage: field => '入力内容が正しくありません',
        validate: value => /(?=.*[a-zA-Z])(?=.*[\d])[\w\W]{6,20}/.test(value)  // 验证条件
      });
      Validator.extend('reNewPwd', {
        getMessage: field => 'パスワードが一致しません',
        validate: value => this.newPwd === this.reNewPwd // 验证条件
      });
      this.validator.attach({name: 'yuanPwd', rules: 'required|yuanPwd|', alias: '原パスワード'});
      this.validator.attach({name: 'newPwd', rules: 'required|newPwd|', alias: '新パスワード'});
      this.validator.attach({name: 'reNewPwd', rules: 'required|reNewPwd', alias: 'パスワード確認'});
      this.$set(this, 'errors', this.validator.errors);
    },
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .change_pwd {
      width: 100%;
      display: flex;
      align-content: center;
      flex-direction: column;
      .change_pwdTop {
        height: 50px;
        background-color: $TitColor;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        color: $whiteColor;
        span:nth-child(1),
        span:nth-child(3) {
          width: 50px;
          display: inline-block;
          height: 50px;
          img {
            margin-top: 10px;
            margin-left: 10px;
          }
        }
      }
      .change_pwd_input {
        width: 7.5rem;
        height: 35px;
        margin: 0 auto;
        background-color: white;
        border: 1px solid $fontColor;
        margin-top: 30px;
        border-radius: 25px;
        input {
          width: 90%;
          height: 34px;
          background-color: white;
          margin-left: 5%;
          border: none;
          outline: none;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-left: 5%;
        }
      }
      .change_pwd_input:nth-child(1) {
        margin-top: 50px;
      }
      button {
        margin: 0 auto;
        text-align: center;
        color: white;
        background-color: $fontColor;
        letter-spacing: $letter;
        font-size: 16px;
        border: none;
        outline: none;
        width: 50%;
        height: 35px;
        border-radius: 5px;
        margin-top: 40/$default-w+rem;
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .change_pwd {
      margin: 0 auto;
      height: 500px;
      background-color: $bgcolor;
      display: flex;
      align-content: center;
      flex-direction: column;
      .change_pwdTop {
        display: none;
      }
      .change_pwd_input {
        width: 400px;
        height: 35px;
        margin: 0 auto;
        background-color: white;
        border: 1px solid $fontColor;
        margin-top: 30px;
        input {
          width: 385px;
          height: 35px;
          background-color: white;
          margin-left: 15px;
          border: none;
          outline: none;
        }
        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      }
      button {
        text-align: center;
        color: white;
        background-color: $fontColor;
        letter-spacing: 10px;
        font-size: 16px;
        border: none;
        outline: none;
        width: 300px;
        height: 35px;
        margin: 0 auto;
        border-radius: 5px;
        margin-top: 30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/personal/change_pwd.vue